<template>
  <div class="home">
    <Banner />
    <SecurityNotice />
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import Banner from '@/components/Home/Banner.vue'
import SecurityNotice from '@/components/Home/SecurityNotice.vue'

const { t } = useI18n()
</script>

<style scoped lang="scss">
.home {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.main-content {
  position: relative;
  z-index: 2;
  background: #fff;
  padding: 40px 0;
}

@media screen and (max-width: 768px) {
  .main-content {
    padding: 20px 0;
  }
}
</style> 